<template>
	<div class="login_wrap" @click="close">
		<div class="login_body">
			<a href="javascript:;" class="login_close" @click="close"></a>
			<div class="login_title">微信账号登陆</div>
			<div class="login_qrcode">
				<iframe :src="$store.state.loginUrl" sandbox="allow-scripts allow-top-navigation"></iframe>
			</div>
			<div class="login_tips">
				<p>请使用微信扫描二维码登陆{{tips}}</p>
				<p>【玩辰提速】</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data: function() {
		return {
			tips: ""
		};
	},
	mounted: function() {
		let _that = this;
		if (window.KDTS) {
			window.KDTS.isHandleBack(true);
		}
		window.handleBack = function() {
			_that.close();
		};
	},
	methods: {
		close: function() {
			if (window.KDTS) {
				window.KDTS.isHandleBack(false);
			}
			this.$store.state.isShowLogin = false;
		}
	}
};
</script>

<style lang="less" scoped>
.login_wrap {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9;

	.login_body {
		width: 360px;
		text-align: center;
		background-color: #ffffff;
		position: relative;
		border-radius: 10px;
		overflow: hidden;

		.login_close {
			position: absolute;
			top: 0;
			right: 0;
			width: 50px;
			height: 50px;
			background-image: url(../assets/login_close.png);
			background-repeat: no-repeat;
			background-size: 100% 100%;
			cursor: pointer;
			display: block;
		}

		.login_title {
			font-weight: bolder;
			font-size: 24px;
			color: #666666;
			margin-top: 50px;
			margin-bottom: 30px;
		}

		.login_qrcode {
			width: 220px;
			height: 220px;
			overflow: hidden;
			margin: 0 auto;
			background-color: #fff;
			text-align: center;

			iframe {
				display: block;
				margin: auto;
				width: 290px;
				-webkit-transform: scale(0.8);
				transform: scale(0.8);
				height: 428px;
				position: relative;
				right: 37px;
				top: -84px;
			}
		}

		.login_tips {
			height: 50px;
			width: 280px;
			border-radius: 25px;
			background-color: #f1f1f1;
			margin: 0 auto;
			margin-bottom: 45px;
			margin-top: 20px;
			color: #999999;
			font-size: 14px;
			overflow: hidden;

			p {
				line-height: 20px;
			}

			p:first-child {
				margin-top: 5px;
			}
		}
	}
}
</style>